import CircularProgress from "@mui/material/CircularProgress";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import { Form } from "formik";
import * as Yup from "yup";
import { StyledFlex } from "../../styled/flex";
import FormikActions from "../formik/formikActions";
import FormikAutocomplete from "../formik/formikAutocomplete";
import FormikForm from "../formik/formikForm";
import FormikSelect from "../formik/formikSelect";
import CustomDialog from "./customDialog";

const validation = Yup.object({
  id: Yup.string().required("Campo obligatorio"),
});

const EditProviderInUserDialog = ({
  provider,
  providersInUser,
  providers,
  open,
  handleClose,
  addingNewProvider,
  handleSubmit,
  loading,
}) => {
  let availableProviders = [];

  if (addingNewProvider && !loading) {
    availableProviders = providers.filter((p) => {
      let flag = true;
      providersInUser.forEach((pInUser) => {
        if (pInUser.id === p.id) {
          flag = false;
          return;
        }
      });
      return flag;
    });
  }

  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
    >
      {loading ? (
        <CircularProgress
          sx={{ marginLeft: 200, marginTop: 100, marginBottom: 100 }}
          size={40}
        />
      ) : (
        <div>
          <DialogTitle>
            {addingNewProvider
              ? "Asociar prestador"
              : "Editar prestador asociado"}
          </DialogTitle>
          <FormikForm
            initialValues={provider}
            validationSchema={validation}
            onSubmit={(values) => {
              handleSubmit(values, addingNewProvider);
            }}>
            {({ setFieldValue }) => (
              <Form>

                <DialogContent>
                  <StyledFlex.ColumnContainer>
                    {addingNewProvider ? (
                      <FormikAutocomplete
                        name="id"
                        label="Prestador"
                        options={providers}
                        renderOption={(option) =>
                          `${option.id} - ${option.nombre}`
                        }
                        filterOptions={(option) => option.id + option.nombre}
                      />
                    ) : (
                      <FormikSelect
                        name="id"
                        value={provider.id}
                        label="Prestador"
                        disabled>
                        <MenuItem value={provider.id}>
                          {provider.nombre ? provider.nombre : ""}
                        </MenuItem>
                      </FormikSelect>
                    )}
                  </StyledFlex.ColumnContainer>
                </DialogContent>
                <DialogActions>
                  <FormikActions handleCancel={handleClose} />
                </DialogActions>
              </Form>
            )}
          </FormikForm>
        </div>
      )}
    </CustomDialog>
  );
};

export default EditProviderInUserDialog;
